import { ETransferStatus } from 'enums';

export const transferStatusStyles: Record<
  ETransferStatus | string,
  { textColor: string; backgroundColor: string }
> = {
  [ETransferStatus.PENDING_APPROVAL]: {
    textColor: '#FAAD14',
    backgroundColor: '#FAAD141A',
  },
  [ETransferStatus.IN_TRANSIT]: {
    textColor: '#1E88E5',
    backgroundColor: '#1E88E50D',
  },
  [ETransferStatus.IN_PROGRESS]: {
    textColor: '#FFA500',
    backgroundColor: '#FFA5001A',
  },
  [ETransferStatus.COMPLETED]: {
    textColor: '#43A047',
    backgroundColor: '#43A0470D',
  },
  [ETransferStatus.CANCELLED]: {
    textColor: '#E53935',
    backgroundColor: '#E539350D',
  },
  [ETransferStatus.REJECTED]: {
    textColor: '#B71C1C',
    backgroundColor: '#B71C1C0D',
  },
};

export const getTransferStatusStyle = (
  status: string
): { textColor: string; backgroundColor: string } => {
  return (
    transferStatusStyles[status] ?? transferStatusStyles[ETransferStatus.CANCELLED]
  );
};
